import React from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import "./settings.css";

export default function UserActivity() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    getUserActivity();
  }, []);
  const getUserActivity = async () => {
    await axios
      .get(`${process.env.REACT_APP_URL}/api/idp/v2/user/activity`, {
        headers: {
          Authorization: sessionStorage.getItem("token"),
        },
      })
      .then((res) => {
        setRows(res.data.data);
      })
      .catch((err) => {
        toast.error("An error occurred");
      });
  };

  const days = Array.from({ length: 30 }, (_, i) => {
    const date = new Date();
    date.setDate(date.getDate() - (i + 1));
    return date.getDate(); // faqat kun raqami
  }).reverse();



  return (
    <div className="u-activity">
      {rows.length > 0 && <h2>User activity</h2>}
      {rows.length > 0 && <div className="ua">
          <span className="ua-name"></span>
          <span className="ua-activity">
            {days.map((item) => (
              <span key={item}>
                  <span className="ua-block">
                    {item}
                  </span>
              </span>
            ))}
          </span>
        </div>}
      {rows.map((row) => (
        <div key={row.id} className="ua">
          <span className="ua-name">{row.name}</span>
          <span className="ua-activity">
            {row.items.map((item) => (
              <span key={item.date}>
                <Tooltip
                  title={
                    <div>
                      <div>{(item.login ? item.login + " login, " : "") + secondtotime(item.seconds)}</div>
                      <div>{item.date}</div>
                      <div>{row.name}</div>
                    </div>
                  }
                >
                  <span className="ua-block">
                    <span className={"ua-item uad" + degree(item.login)} />
                  </span>
                </Tooltip>
              </span>
            ))}
          </span>
        </div>
      ))}
    </div>
  );
}

function secondtotime(sec = 0) {
  let text = "";
  if (sec >= 3600) {
    text += parseInt(sec / 3600) + "h ";
    sec = sec - parseInt(sec / 3600) * 3600;
  }
  if (sec >= 60) {
    text += parseInt(sec / 60) + "m ";
    sec = sec - parseInt(sec / 60) * 60;
  }
  text += sec + "s online";
  return text;
}

function degree(sec) {
  if (sec === 0) return 1;
  else if (sec < 2) return 2;
  else if (sec < 4) return 3;
  else if (sec < 8) return 4;
  else return 5;
}
